import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AdminCatalogManagementScreen from './pages/admin-catalog-management-screen';
import AdminCategoriesScreen from './pages/admin-categories';
import BookCatalogBrowseScreen from './pages/book-catalog-browse-screen';
import BookDetailScreen from './pages/book-detail-screen';
import BibleDetailScreen from './pages/bible-detail-screen';
import ThingDetailScreen from './pages/thing-detail-screen';
import ProductDetailRouter from './components/ProductDetailRouter';
import LoginScreen from './pages/login-screen';
import AdminDashboardScreen from './pages/admin-dashboard-screen';
import AdminHelpScreen from './pages/admin-help-screen';
import DatabaseDebugger from './components/debug/DatabaseDebugger';
import ImageDebugger from './components/debug/ImageDebugger';
import AdminAuthorsScreen from './pages/admin-authors';
import AdminReports from "pages/admin-reports";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        <Route path="/" element={<BookCatalogBrowseScreen />} />
        <Route path="/admin-catalog-management-screen" element={<AdminCatalogManagementScreen />} />
        <Route path="/admin-catalog-management" element={<AdminCatalogManagementScreen />} />
        <Route path="/admin-categories" element={<AdminCategoriesScreen />} />
        <Route path="/book-catalog-browse-screen" element={<BookCatalogBrowseScreen />} />
        <Route path="/book-detail-screen" element={<BookDetailScreen />} />
        <Route path="/bible-detail" element={<BibleDetailScreen />} />
        <Route path="/thing-detail" element={<ThingDetailScreen />} />
        <Route path="/product-detail" element={<ProductDetailRouter />} />
        <Route path="/login-screen" element={<LoginScreen />} />
        <Route path="/admin-dashboard-screen" element={<AdminDashboardScreen />} />
        <Route path="/admin-help-screen" element={<AdminHelpScreen />} />
        <Route path="/admin-authors" element={<AdminAuthorsScreen />} />
        <Route path="/admin-reports" element={<AdminReports />} />
        <Route path="/debug" element={<DatabaseDebugger />} />
        <Route path="/image-debug" element={<ImageDebugger />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
